import React, { useState, useEffect } from "react";
import { Combobox } from "@salesforce/design-system-react";

const Picklist = ({ id, name, label, options, selected, onUpdate }) => {
  const selection = () => options?.find((option) => option.label == selected);

  return (
    <div className="slds-p-top_x-small form-item">
      <Combobox
        id="combobox-readonly-single"
        events={{
          onSelect: (event, data) => {
            onUpdate(name, event, data);
          },
        }}
        labels={{
          label: label,
          placeholder: "Search Salesforce",
        }}
        options={options}
        selection={[selection()]}
        variant="readonly"
      />
    </div>
  );
};

Picklist.defaultProps = {
  label: "REPLACE-picklist-label",
  options: [],
  onUpdate: () => console.log("ATTACH FORM UPDATE FUNCTION"),
};

export default Picklist;
